/**
 * 전체 사이트 메뉴 구조를 중앙에서 관리하는 파일
 * Nav, SiteMap, SubPage 등에서 동일한 메뉴 데이터를 사용합니다.
 */

// 공통 페이지 설명
const COMMON_DESCRIPTION =
  '중구행복돌봄센터는 함께하는 가치로 사람중심, 상호신뢰와 배려, 같이 삶을 실현하는 공동체입니다.';

/**
 * 메뉴 데이터 객체
 * 각 메인 메뉴별로 id, label, path, subMenus를 정의합니다.
 */
export const MENU_DATA = {
  // 법인소개
  introduce: {
    id: 'introduce',
    label: '법인소개',
    path: '/introduce/1',
    description: COMMON_DESCRIPTION,
    subMenus: [
      { id: '1', label: '이사장 인사말', path: '/introduce/1' },
      { id: '2', label: '법인 연혁', path: '/introduce/2' },
      // { id: '3', label: '중구행복돌봄센터 인사말', path: '/introduce/3' },
      // { id: '4', label: '중구행복돌봄센터 연혁', path: '/introduce/4' },
      { id: '3', label: '조직안내', path: '/introduce/3' },
      { id: '4', label: '오시는길', path: '/introduce/4' },
    ],
  },

  // 사업안내
  care: {
    id: 'care',
    label: '사업안내',
    path: '/care/1',
    description:
      '훈련된 전문 돌봄종사자들이 최적화된 서비스로 여러분을 찾아갑니다.',
    subMenus: [
      { id: '1', label: '장애인활동지원', path: '/care/1' },
      { id: '2', label: '노인장기요양서비스', path: '/care/2' },
      { id: '3', label: '가사간병방문지원서비스', path: '/care/3' },
      { id: '4', label: '돌봄SOS서비스', path: '/care/4' },
      { id: '5', label: '사회주택', path: '/care/5' },
      { id: '6', label: '사회연대경제', path: '/care/6' },
      { id: '7', label: '디지털사회혁신', path: '/care/7' },
      // { id: '8', label: '상담 문의', path: '/care/8' },
    ],
  },

  // 후원안내
  support: {
    id: 'support',
    label: '후원안내',
    path: '/support/1',
    description: COMMON_DESCRIPTION,
    subMenus: [
      { id: '1', label: '더채움돌봄펀드 후원', path: '/support/1' },
      { id: '2', label: '봉사활동', path: '/support/2' },
    ],
  },

  // 창업지원
  startup: {
    id: 'startup',
    label: '창업지원',
    path: '/startup/1',
    description: COMMON_DESCRIPTION,
    subMenus: [{ id: '1', label: '창업지원 프로그램', path: '/startup/1' }],
  },

  // 커뮤니티
  community: {
    id: 'community',
    label: '커뮤니티',
    path: '/notice',
    description: COMMON_DESCRIPTION,
    subMenus: [
      { id: 'notice', label: '공지사항', path: '/notice' },
      { id: 'data', label: '언론보도', path: '/data' },
      { id: 'photo', label: '포토갤러리', path: '/photo' },
    ],
  },
};

/**
 * 메인 메뉴 배열
 * Nav, SiteMap 등에서 전체 메뉴를 순회할 때 사용합니다.
 */
export const MAIN_MENU = [
  MENU_DATA.introduce,
  MENU_DATA.care,
  MENU_DATA.support,
  MENU_DATA.startup,
  MENU_DATA.community,
];

/**
 * 서브메뉴명 매핑 헬퍼 함수
 * 페이지에서 no를 받아 해당하는 서브메뉴 label을 반환합니다.
 *
 * @param {string} menuKey - MENU_DATA의 키 (예: 'introduce', 'care')
 * @param {string} no - 서브메뉴 id
 * @returns {string} 서브메뉴 label
 */
export const getSubMenuLabel = (menuKey, no) => {
  const menu = MENU_DATA[menuKey];
  if (!menu || !menu.subMenus) return '';

  const subMenu = menu.subMenus.find((item) => item.id === no);
  return subMenu ? subMenu.label : '';
};
